import React from 'react';
import Autocomplete from "react-autocomplete";
import { Tooltip } from 'reactstrap';

export default class AutocompleteInput extends React.Component {
    constructor(props) {
        super(props);
        this.toggleToolTip = this.toggleToolTip.bind(this);
        this.onClickPreOpen = this.onClickPreOpen.bind(this);
        this.onClickClear = this.onClickClear.bind(this);
        this.onClickSearch = this.onClickSearch.bind(this);
        this.state = {
            tooltipOpen: false,
            hasFocus: false,
            hasSelect: false,
            enteringSearchText: false,
            invalidInput: false
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    toggleToolTip() {
        this.setState({ tooltipOpen: !this.state.tooltipOpen });
    }

    onFocus() {
        this.setState({ hasFocus: true });
    }

    onBlur() {
        this.setState({
            hasFocus: false, enteringSearchText: false
        }, function () {
            this.isInvalid();
        });
    }

    onChange(e) {       
        if (this._isMounted) {
            this.props.onChange(e, e.target.value);
        }
    }

    onSelect(val, item) {     
        if (this._isMounted) {
            this.props.onSelect(val, item);
        }

        this.setState({ hasSelect: true, invalidInput: false, enteringSearchText: false });
    }

    commitSelect() {
        const highlightedIndex = this.typeaheadInput.state.highlightedIndex;
        const items = this.typeaheadInput.props.items;
        if (this._isMounted && highlightedIndex) {
            this.props.onSelect(items[highlightedIndex].label, items[highlightedIndex]);
        }
    }

    onKeyDown(e) {
        if (e.key === 'Tab') {
            if (this.state.enteringSearchText) {
                this.commitSelect();
            }
            else {
                this.setState({ hasSelect: false });
            }
            this.setState({ enteringSearchText: false });
        }
        else if (e.key === 'Enter') {
            if (this.state.enteringSearchText) {
                this.commitSelect();
            }
            else {
                if (!this.state.invalidInput) {
                    if (this.props.submitForm) {
                        this.props.submitForm();
                    }
                }
            }
            this.setState({ enteringSearchText: false });
        }
        else {
            this.setState({ hasSelect: false, enteringSearchText: true });
            this.isInvalid();
        }
    }

    onPaste() {
        this.setState({ enteringSearchText: true });
    }

    isInvalid() {
        this.setState({
            invalidInput: this.props.required ? !this.props.value : false
        }, function () {
            if (this.props.isInvalid) {
                this.props.isInvalid(this.state.invalidInput);
            }
        });
    }

    onClickPreOpen(preOpen) {
        if (this._isMounted && this.props.onClickPreOpen && preOpen) {
            this.onBlur();
            this.props.onClickPreOpen();
        }
        return true;
    }

    onClickClear() {
        if (this._isMounted) {
            this.props.onChange(null, "");
        }
    }

    onClickSearch(value) {
        if (this._isMounted) {
            if (value)
                this.props.onClickSearch(value);
        }
    }

    render() {
        const {
            placeholder, value, itemList, inputErrorMsg, tooltipID, tooltipMsg, prependIcon,
            autoHighlight, selectOnBlur, loading, noResults, preOpen, isSearchButton, autoFocus
        } = this.props;
        const inputPropsSettings = {            
            placeholder: placeholder, className: "form-control", autoFocus: autoFocus,
            onFocus: () => this.onFocus(), onBlur: () => this.onBlur(),
            onKeyDown: e => this.onKeyDown(e), onPaste: () => this.onPaste(),
            "aria-label": placeholder,
            "data-lpignore": true
        };
        const { hasFocus, invalidInput, enteringSearchText } = this.state;
        const containerClass = (value ? " input-not-empty" : "") + (invalidInput ? " input-invalid" : "") 
            + (hasFocus ? " input-focused" : "") + (((tooltipID && tooltipMsg) || isSearchButton) ? " input-append" : "");
        const openDropdown = enteringSearchText && typeof value !== 'undefined' && value.length > 1;

        return (
            <div className={"il-group autocomplete-group" + containerClass}>
                <Autocomplete wrapperStyle={{ display: 'flex' }}
                    menuStyle={{
                        borderRadius: '0px',
                        boxShadow: '0 1px 7px 0 #C8C8C8',
                        background: 'rgba(255, 255, 255, 0.9)',
                        padding: '0',
                        fontSize: '14px',
                        position: 'fixed',
                        overflow: 'auto',
                        maxHeight: '250px',
                        zIndex: '998'
                    }}
                    inputProps={inputPropsSettings}
                    items={itemList}
                    isItemSelectable={(item) => !item.category || item.label !== item.category}
                    getItemValue={item => item.id}
                    renderItem={(item, highlighted) => {
                        const itemLabel = item.category && item.label === item.category ? "suggestion-category" : "suggestion-item";
                        return (
                            <div className={itemLabel + (highlighted ? ' suggestion-highlighted' : '')} key={item.id}>
                                {item.label}
                            </div>
                        );
                    }}
                    open={openDropdown}
                    autoHighlight={autoHighlight}
                    selectOnBlur={selectOnBlur}
                    value={value}
                    ref={(instance) => (this.typeaheadInput = instance)}
                    onChange={e => this.onChange(e)}
                    onSelect={(value, item) => this.onSelect(value, item)}
                />
                {tooltipID && tooltipMsg &&
                    <div className="input-icon-append">
                        <span className="icon-info" id={tooltipID} />
                        <Tooltip placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={tooltipID} toggle={this.toggleToolTip}>
                            {tooltipMsg}
                        </Tooltip>
                    </div>
                }
                {isSearchButton &&
                    <div className="input-icon-append">
                        <span className="icon-search" onClick={() => this.onClickSearch(value)} />
                    </div>
                }
                {value && <span className="clear-btn" aria-label="clear button" onClick={() => this.onClickClear()}><span className="icon-input-clear" /></span>}
                <div className="il-label" aria-hidden="true">
                    {prependIcon && <span className={prependIcon} />} {placeholder}
                </div>
                {inputErrorMsg &&
                    <div className="input-error-msg">{inputErrorMsg}</div>
                }
                {preOpen && !noResults && !loading && !value &&
                    <div className="preopen-container" onBlur={(e) => this.onBlur(e)} onClick={(e) => this.onClickPreOpen(preOpen)}>{preOpen}</div>
                }
                {noResults && !loading && hasFocus && value &&
                    <div className="no-results-dropdown">No results </div>
                }
                {loading &&
                    <div className="loading-results-dropdown">
                        <div className="spinner"><div className="bounce1" /><div className="bounce2" /><div className="bounce3" /></div>
                    </div>
                }
            </div>
        );
    }
}